<template>
  <div class="template-layout layers">
    <div class="scroller" ref="scroller">
      <div class="long-content" ref="content">
        <div class="top-taller"></div>

        <div class="radiance-set-row">
          <div>
           <img class="radiance-set" src="./img/radiance-set.png" alt="">
          </div>
        </div>

        <div class="radiance-title">
          <span v-if="SC.U === ENG">
            Radiant Eye Cream Charity Set
          </span>
          <span v-if="SC.U === CHI">
            修護眼霜慈善套裝
          </span>
        </div>

        <div class="radiance-desc-row">
          <div class="radiance-desc">
            <span v-if="SC.U === ENG">
              Clé de Peau Beauté will launch a Radiant Eye Cream Charity Set, for the women seeking their fullest radiance. The Charity set will be available in all <span class="break375"><br/></span>Clé de Peau Beauté stores from April 4. Your support makes a great difference for the children by granting their wishes and enriching their life experiences.
            </span>
            <span v-if="SC.U === CHI">
              由4月4日起，Clé de Peau Beauté會在全線概念店及專櫃推出「修護眼霜慈善套裝」，讓一眾女士展現盈亮閃爍魅力，實現由內而外綻放閃耀光芒。淨收入將用於捐助願望成真基金， 為願望童帶來更多關愛和希望。
            </span>
          </div>
        </div>

        <div class="radiance-promo-row">
          <div class="radiance-promo">
            <span v-if="SC.U === ENG">
              *Net Proceed of the Radiant Eye Cream Charity Set will be donated to Make-A-Wish to support children in need. **Limited quantity, while stock lasts.
            </span>
            <span v-if="SC.U === CHI">
              *Clé de Peau Beauté「修護眼霜慈善套裝」淨收益將捐贈予願望成真基金，幫助有需要兒童。 **「修護眼霜慈善套裝」數量有限，售完即止。
            </span>
          </div>
        </div>

        <div class="detail-row">
          <Detail v-if="SC.U === ENG" />
          <DetailCHI v-if="SC.U === CHI" />
        </div>

        <div class="cta-row" @click="goStore">
          <img class="cta-frame" src="./img/cta-frame.svg" />
          <div class="cta">
            <span v-if="SC.U === ENG">
              OUR STORE
            </span>
            <span v-if="SC.U === CHI">
              分店詳情
            </span>
          </div>
        </div>

        <div class="bottom-taller"></div>
        <!-- <div class="taller"></div>
        <div class="taller"></div> -->
      </div>
    </div>
    <FloatMenu class="float-menu" @diamond="() => { fsMenu = !fsMenu }" />
    <FullMenu class="full-menu" v-show="fsMenu" @close="() => { fsMenu = false }" @lang="() => { Text.toggle() }" />
  </div>
</template>

<script>
import FloatMenu from '@/components/DOM/FloatMenu/FloatMenu.vue'
import FullMenu from '@/components/DOM/FullMenu/FullMenu.vue'
import * as Text from '@/components/DOM/Text/Text.js'

import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'

import Detail from './Detail'
import DetailCHI from './DetailCHI'

// import Instruction from './Instruction.vue'

export default {
  components: {
    FloatMenu,
    FullMenu,
    Detail,
    DetailCHI
    // Instruction
  },
  data () {
    return {
      Text,
      SC: Text.state,
      T: Text.T,
      ENG: Text.ENG,
      CHI: Text.CHI,

      fsMenu: false,
      clean () {}
    }
  },
  mounted () {
    ScrollMonitor.setPercentage(0)
    this.setupScroll()
    window.addEventListener('resize', () => {
      this.setupScroll()
    })
  },
  methods: {
    goStore () {
      var href = document.createElement('a')
      href.href = 'http://www.cledepeau-beaute.com/hk/store/'
      href.target = '_blank'
      href.click()
    },
    setupScroll () {
      this.clean()
      var scroller = this.$refs['scroller']
      if (!scroller) {
        return
      }
      var content = this.$refs['content']
      var scrollerHeight = scroller.getBoundingClientRect().height
      var ccontentHeight = content.getBoundingClientRect().height
      var onScroll = () => {
        this.scrollPos = scroller.scrollTop

        ScrollMonitor.state.percentage = 0.2 * (scroller.scrollTop) / (ccontentHeight - scrollerHeight)
        // console.log(ScrollMonitor.state.percentage)
      }
      scroller.addEventListener('scroll', onScroll, false)

      this.clean = () => {
        if (scroller) {
          scroller.removeEventListener('scroll', onScroll)
        }
      }
    }
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style scoped>
.template-layout{
  color: white;
}
.full-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.float-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.layers{
  width: 100%;
  height: 100%;
  position: relative;
  overflow:hidden;
}

.scroller{
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
}

.top-taller{
  height: 90px;
}

.taller{
  height: 75vh;
}

.bottom-taller{
  height: 50px;
}

.radiance-set-row{
  display: flex;
  justify-content: center;
}

.radiance-set{
  width: 300px;
}

.radiance-title{
  margin-top: -25px;

  text-transform: uppercase;
  /* Radiant Eye Cream Ch: */
  /* border: 1px solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 16px;
  color: #CEBC9E;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
}

.radiance-desc-row{
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

.radiance-desc{
  width: 280px;
  /* A limited edition di: */
  border: 0 solid #CEBC9E;
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1px;
  line-height: 20px;
}

@media screen and (min-width: 374px) {
  .radiance-desc{
    width: 320px;
  }
}


.radiance-promo-row {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
.radiance-promo{
  width: 280px;
  /* Net Proceed of the R: */
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 14px;
  color: #CEBC9E;
  letter-spacing: 1px;
  line-height: 20px;
}

@media screen and (min-width: 374px) {
  .radiance-promo{
    width: 320px;
  }
}

.detail-row{
  margin-top: 15px;
  display: flex;
  justify-content: center;
}


@media screen and (min-width: 319px) {
  .detail-row{
    transform: scale(0.95);
  }
}

@media screen and (min-width: 375px) {
  .detail-row{
    transform: scale(1.0);
  }
}

.cta-row{
  cursor: pointer;
  margin-top: 15px;
  position: relative;
  display: flex;
  justify-content: center;
}
.cta-frame{
  position: absolute;
  top: 0;
  left: calc(50% - 314px / 2);
}
.cta{
  text-transform: uppercase;
  width: 304px;
  height: calc(55px + 10px);
  display: flex;
  justify-content: center;
  align-items: center;
  /* Our store: */
  border: 0 solid #FFFFFF;
  font-family: CronosPro-LtDisp, PingFangTC-Light;;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .radiance-set{
    width: 500px;
    height: 464px;
  }
  .radiance-title{
    font-size: 22px;
  }
  .radiance-desc{
    width: 590px;
  }
  .radiance-promo{
    width: 590px;
  }
  .detail-row svg{
    width: 400px;
    height: 330px;
  }
  .cta-frame{
    width: 380px;
    left: calc(50% - 380px / 2);
  }
  .cta{
    height: 78px;
  }
  .cta-row{
    margin-top: 35px;
  }
  .detail-row{
    margin-top: 35px;
  }
  .radiance-title{
    font-size: 22px;
  }
  .radiance-desc-row{
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/RadianceSet/RadianceSet.vue